import axios from 'axios';

/**
 * Fetch paper sizes from backend
 * @param {Object} options - Query options
 * @param {Boolean} options.includeInactive - Include inactive sizes in response
 * @returns {Promise<Array>} Array of paper size objects with sizeID, sizeName, paperMm, charsPerLine
 */
export const fetchPaperSizes = async (options = {}) => {
    try {
        const response = await axios.get(`${global.SET_API_URL}printerConfig/paperSizes`, {
            params: {
                includeInactive: options.includeInactive ? 1 : 0
            },
            timeout: 5000
        });

        if (response.data && response.data.success && Array.isArray(response.data.data)) {
            return response.data.data;
        }

        return getDefaultPaperSizes();
    } catch (error) {
        console.warn('Failed to fetch paper sizes from API:', error.message);
        return getDefaultPaperSizes();
    }
};

/**
 * Get default paper sizes (fallback)
 * @returns {Array} Default paper sizes
 */
export const getDefaultPaperSizes = () => [
    { sizeID: 1, sizeName: '58mm Thermal', paperMm: 58, charsPerLine: 32 },
    { sizeID: 2, sizeName: '80mm Thermal', paperMm: 80, charsPerLine: 48 }
];

/**
 * Save or update paper size
 * @param {Object} data - Paper size data
 * @returns {Promise<Object>} Result
 */
export const savePaperSize = async (data) => {
    try {
        const response = await axios.post(`${global.SET_API_URL}printerConfig/paperSize`, data);
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: error.message };
    }
};
